import React, { useState } from 'react'
import styled from 'styled-components'
import SessionDialog from '../../sessions/components/SessionDialog'

const Field = styled.div`
  margin-bottom: 12px;
`
const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
  margin-bottom: 4px;
`
const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
  &:focus {
    outline: 2px solid ${(p) => p.theme?.color?.primary || '#1F3A5F'};
    outline-offset: 1px;
  }
`
const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`
const Select = styled.select`
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
  background: ${(p) => p.theme?.color?.bgRaised || '#fff'};
`

export default function AddMedicineDialog({ open, onClose, onSubmit }) {
  const [name, setName] = useState('')
  const [dosage, setDosage] = useState('')
  const [form, setForm] = useState('TABLET')
  const [frequencyType, setFrequencyType] = useState('DAILY')
  const [timesOfDay, setTimesOfDay] = useState('08:00')
  const [instructions, setInstructions] = useState('')
  const [busy, setBusy] = useState(false)

  async function handleSubmit() {
    setBusy(true)
    try {
      await onSubmit({
        name: name.trim(),
        dosage: dosage.trim() || null,
        form,
        frequencyType,
        timesOfDay: timesOfDay
          .split(/[,\s]+/)
          .map((s) => s.trim())
          .filter(Boolean),
        instructions: instructions.trim() || null,
        prescribedBy: 'self',
      })
      // reset
      setName('')
      setDosage('')
      setInstructions('')
      onClose()
    } finally {
      setBusy(false)
    }
  }

  return (
    <SessionDialog
      open={open}
      title="Add a medicine"
      subtitle="Anything you take that isn't already prescribed in the portal."
      primaryLabel="Add medicine"
      primaryDisabled={!name.trim()}
      primaryLoading={busy}
      onPrimary={handleSubmit}
      onClose={onClose}
    >
      <Field>
        <Label>Name</Label>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Vitamin D3"
        />
      </Field>
      <Row>
        <Field>
          <Label>Dose</Label>
          <Input
            value={dosage}
            onChange={(e) => setDosage(e.target.value)}
            placeholder="e.g. 1 tablet, 1000 IU"
          />
        </Field>
        <Field>
          <Label>Form</Label>
          <Select value={form} onChange={(e) => setForm(e.target.value)}>
            <option value="TABLET">Tablet</option>
            <option value="CAPSULE">Capsule</option>
            <option value="SYRUP">Syrup</option>
            <option value="INHALER">Inhaler</option>
            <option value="INJECTION">Injection</option>
            <option value="OTHER">Other</option>
          </Select>
        </Field>
      </Row>
      <Row>
        <Field>
          <Label>Frequency</Label>
          <Select value={frequencyType} onChange={(e) => setFrequencyType(e.target.value)}>
            <option value="DAILY">Daily</option>
            <option value="WEEKLY">Weekly</option>
            <option value="AS_NEEDED">As needed</option>
          </Select>
        </Field>
        {frequencyType !== 'AS_NEEDED' && (
          <Field>
            <Label>Times of day</Label>
            <Input
              value={timesOfDay}
              onChange={(e) => setTimesOfDay(e.target.value)}
              placeholder="08:00, 20:00"
            />
          </Field>
        )}
      </Row>
      <Field>
        <Label>Instructions (optional)</Label>
        <Input
          value={instructions}
          onChange={(e) => setInstructions(e.target.value)}
          placeholder="e.g. with food"
        />
      </Field>
    </SessionDialog>
  )
}
